import CarouselItem from './CarouselItem';


CarouselItem.install = function(Vue) {
  Vue.component('JskCarouselItem', CarouselItem);
};

export default CarouselItem;
